import type { GetHouseNextValidPeriodRepository } from "./interfaces/GetHouseNextValidPeriodRepository";
import type { GetHouseNextValidPeriodPresentation } from "./interfaces/GetHouseNextValidPeriodPresentation";

export default class GetHouseNextValidPeriodUseCase {
  constructor(private repository: GetHouseNextValidPeriodRepository) {}

  async execute(
    presenter: GetHouseNextValidPeriodPresentation,
    houseId: string
  ) {
    const response = await this.repository.getHouseNextValidPeriod({
      houseId,
    });

    if (response.data) {
      // mobile app - axios
      presenter.displayHouseNextValidPeriod(response.data);
    } else if (response && "houseId" in response) {
      // web - ofetch (no data prop)
      presenter.displayHouseNextValidPeriod(
        response as unknown as {
          houseId: string;
          startDate: string;
          endDate: string;
        }
      );
    } else {
      presenter.displayHouseNextValidPeriod(null);
    }
  }
}
